define('SageDotCom/Components/AmazonLoginModal',[
    "jquery"
],
    function ($) {
        function AmazongLoginModal(scope) {
            const $modal = $(".modal", scope);            

            // show the modal once it has been clicked
            setTimeout(function () {     
                const $newModal = $modal.detach();
                $('body').append($newModal);
                $newModal.modal({ backdrop: 'static', keyboard: false });
                $newModal.focus();
                const $close = $(".dismiss", $newModal);
                $close.on("click", function(e) {
                    e.preventDefault();
                    $newModal.modal('hide');
                })
            }, 250);
        }   

        AmazongLoginModal.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new AmazongLoginModal(args.scope);
        };

        return AmazongLoginModal;
    });

